module.exports = __webpack_public_path__ + "static/media/image1.650c1fd2.jpeg";